var _defs, _g, _line, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewWindowtoFloor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "208px",
    height: "194px",
    viewBox: "0 0 555 518.3",
    enableBackground: "new 0 0 555 518.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t@font-face {\r\n\t\t\tfont-family: \"proximanova-nova\";\r\n\r\n\t\t\tsrc: url('https://doopsalta2.com/Fonts/proxima-nova-three.woff2') format('woff2'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.woff') format('woff'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.otf') format('opentype');\r\n\t\t\tfont-style: normal;\r\n\t\t\t}\r\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 87.7,
    y1: 19.5,
    x2: 41.3,
    y2: 19.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 64.5,
    y1: 34.2,
    x2: 64.5,
    y2: 497.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "55.5,36.8 64.5,21.3 73.5,36.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "55.5,495 64.5,510.5 73.5,495  "
  })))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 0,
    y1: 513.5,
    x2: 460,
    y2: 513.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 19.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 42.6,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M471.4,513.2v-15.3h10.1v1.7h-8.1v4.9h8v1.7h-8v7H471.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M486.1,513.2v-15.3h1.9v13.6h7.1v1.7H486.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M500.3,509.6c-0.6-1.2-0.9-2.6-0.9-4.1s0.3-2.8,0.9-4.1c0.6-1.2,1.5-2.2,2.7-2.8s2.5-1,4-1 c1.5,0,2.8,0.3,4,1c1.2,0.7,2.1,1.6,2.7,2.8c0.6,1.2,1,2.6,1,4.1s-0.3,2.8-1,4.1c-0.6,1.2-1.5,2.2-2.7,2.8c-1.2,0.7-2.5,1-4,1 c-1.5,0-2.8-0.3-4-1S500.9,510.8,500.3,509.6z M501.3,505.6c0,1.2,0.2,2.2,0.7,3.2c0.5,0.9,1.1,1.7,2,2.2c0.9,0.5,1.9,0.8,3,0.8 s2.1-0.3,3-0.8c0.9-0.5,1.5-1.3,2-2.2s0.7-2,0.7-3.2c0-1.8-0.5-3.3-1.6-4.5c-1-1.2-2.4-1.8-4.1-1.8c-1.7,0-3.1,0.6-4.1,1.8 C501.8,502.2,501.3,503.7,501.3,505.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M520.2,509.6c-0.6-1.2-0.9-2.6-0.9-4.1s0.3-2.8,0.9-4.1c0.6-1.2,1.5-2.2,2.7-2.8s2.5-1,4-1 c1.5,0,2.8,0.3,4,1c1.2,0.7,2.1,1.6,2.7,2.8c0.6,1.2,1,2.6,1,4.1s-0.3,2.8-1,4.1c-0.6,1.2-1.5,2.2-2.7,2.8c-1.2,0.7-2.5,1-4,1 c-1.5,0-2.8-0.3-4-1S520.8,510.8,520.2,509.6z M521.2,505.6c0,1.2,0.2,2.2,0.7,3.2c0.5,0.9,1.1,1.7,2,2.2c0.9,0.5,1.9,0.8,3,0.8 s2.1-0.3,3-0.8c0.9-0.5,1.5-1.3,2-2.2s0.7-2,0.7-3.2c0-1.8-0.5-3.3-1.6-4.5c-1-1.2-2.4-1.8-4.1-1.8c-1.7,0-3.1,0.6-4.1,1.8 C521.7,502.2,521.2,503.7,521.2,505.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M539.8,513.2v-15.3h6.2c1.4,0,2.6,0.4,3.5,1.3c0.9,0.8,1.3,2,1.3,3.4c0,0.7-0.1,1.3-0.3,1.8 c-0.2,0.6-0.5,1-0.9,1.4c-0.4,0.4-0.8,0.7-1.3,0.9s-1,0.3-1.5,0.4l4.1,6.2h-2.3l-3.9-6.1h-3.1v6.1H539.8z M541.7,505.4h4 c0.9,0,1.6-0.3,2.2-0.8c0.6-0.5,0.9-1.3,0.9-2.1s-0.3-1.6-0.9-2.1c-0.6-0.5-1.3-0.8-2.2-0.8h-4V505.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWindowtoFloor);
export default __webpack_public_path__ + "static/media/new_WindowtoFloor.ebdcf87e931bc37cbe4ea1a495f125db.svg";
export { ForwardRef as ReactComponent };